import { useEffect } from 'react';

import { COACH_TOOLKIT_URL } from '@/constants';

const Toolkit = () => {
  useEffect(() => {
    window.location.href = COACH_TOOLKIT_URL;
  }, []);

  return null;
};

export default Toolkit;
